import type { ComponentType } from 'react';
import {
  MessageSquare,
  Users,
  MessageCircle,
  FileText,
  Target,
  Calendar,
  BookOpen,
} from 'lucide-react';
import type { Guild } from '../../../types';
import type { GuildModuleId } from '../../../stores/guildModeStore';

// The guild's navigation surface — shared by the guild rail (desktop) and
// the mobile module ribbon. Projects stays hidden while a stub and voice
// rooms stay hidden inside Rooms (plan §0.3).
export const GUILD_MODULES: Array<{
  id: GuildModuleId;
  label: string;
  icon: ComponentType<{ className?: string }>;
}> = [
  { id: 'feed', label: 'Feed', icon: MessageSquare },
  { id: 'members', label: 'Members', icon: Users },
  { id: 'rooms', label: 'Rooms', icon: MessageCircle },
  { id: 'pages', label: 'Pages', icon: FileText },
  { id: 'quests', label: 'Quests', icon: Target },
  { id: 'events', label: 'Events', icon: Calendar },
  { id: 'library', label: 'Library', icon: BookOpen },
];

export function enabledGuildModules(guild: Guild | null) {
  if (!guild) return [];
  return GUILD_MODULES.filter(m => guild.modules_enabled?.includes(m.id));
}
